import React from 'react';
import '../../styles/similarQuestions.css';
import { IRCTC_SIMILAR_QUESTIONS } from '../../utils/RailsSEOConstants';
import { navigateTo } from '../../utils/commonUtils';
import PropTypes from 'prop-types';

const SimilarQuestions = ({ customClass }) => {
  return (
    <div className={`${customClass} similarQues`}>
      <ul>
        {IRCTC_SIMILAR_QUESTIONS &&
          IRCTC_SIMILAR_QUESTIONS.map((item) => {
            return (
              <li key={item.question} onClick={() => navigateTo(item.hrefLink)}>
                {item.question}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

SimilarQuestions.propTypes = {
  customClass: PropTypes.string
};
export default SimilarQuestions;
